import * as bip39 from 'bip39';

export default bip39;
